<template>
  <div id="tools">
    <div class="pd0 col btn-group">
      <button @click="sortyBy(0)" type="button" class="the-icons btn btn-style-group border-left">
        <i class="icon-sort"></i> نام
      </button>
      <button @click="sortyBy(1)" type="button" class="the-icons btn btn-style-group">
        <i class="icon-sort"></i> نوع کسب و کار
      </button>
      <!-- <button
        @click="sortyBy(2)"
        type="button"
        class="the-icons btn btn-light border-right"
      >
        <i class="icon-sort"></i> شناسه ملی
      </button> -->
      <button @click="sortyBy(3)" type="button" class="the-icons btn  btn-style-group">
        <i class="icon-sort"></i> تاریخ ایجاد
      </button>

      <button type="button" class="the-icons btn btn-style-group">
        ویرایش
      </button>
    </div>
  </div>
</template>

<script>
import Store from "../../views/profile/store/index";
export default {
  name: "UserBusinessSort",
  store: Store,

  data() {
    return {
      stateItem: this.$store.state.sort,
    };
  },
  methods: {
    sortyBy(typeCode) {
      let type = "";
      switch (typeCode) {
        case 0:
          type = "name";
          break;

        case 1:
          type = "iataCode";
          break;

        case 2:
          type = "nationalNumber";
          break;

        case 3:
          type = "createdDate";
          break;
      }

      this.$emit("sortBy", type);

      // BusEvent.$emit("sortBy", type);

      // this.$store.state.sortItem = type;
    },
  },
};
</script>
<style scoped>


</style>